<div
  mat-dialog-title
  class="modal-title"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <span class="modal-title-label"
    >{{ httpService.getTransation().ChoosePlan }}</span
  >
  <button
    class="modal-close-button"
    mat-icon-button
    matTooltip="{{ httpService.getTransation().Close }}"
    (click)="onClose()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<div
  mat-dialog-content
  class="pricing-modal-content"
>
  <!-- Free Plan Status Indicator -->
  <div class="usage-indicator-compact" *ngIf="isFreeUser && !showUrgencyBanner">
    <span class="free-label">{{ httpService.getTransation().FreePlanStatus }}:</span>
    <span class="stat-value-compact">{{ userPatternCount }}/3</span>
    <span class="stat-label-compact">{{ httpService.getTransation().PatternsCreated }}</span>
    <span class="stat-separator">•</span>
    <span class="stat-limited-compact">{{ httpService.getTransation().NoPDFPrinting }}</span>
  </div>

  <div class="pricing-cards-container" [fxLayout]="itemsDirection" fxLayoutAlign="space-around stretch">
    <!-- MONTHLY PLAN - Featured/Most Popular -->
    <div
      class="subscription-item subscription-item-featured"
      [ngClass]="{ 'subscription-item-selected' : data.subscriptionType === subscriptionTypes.Monthly }"
    >
      <div class="subscription-no-best-value"></div>
      <div class="most-popular-badge">{{ httpService.getTransation().MostPopular }}</div>
      <div class="subscription-title">
        {{ httpService.getTransation().MONTHLY }}
      </div>
      <div class="subscription-price">
        <span class="currency-symbol">$</span><span class="price-number">5</span>
      </div>
      <div class="subscription-subtitle">
        {{ httpService.getTransation().BilledMonthly }}
      </div>
      
      <!-- Simplified Benefits -->
      <div class="benefits-list-compact">
        <div class="benefit-compact">✓ {{ httpService.getTransation().UnlimitedPatterns }}</div>
        <div class="benefit-compact benefit-mobile-simple hidden-mobile">✓ {{ httpService.getTransation().HDExport }}</div>
        <div class="benefit-compact benefit-mobile-simple hidden-mobile">✓ {{ httpService.getTransation().PDFSavePrint }}</div>
        <div class="benefit-compact benefit-mobile-simple hidden-mobile">✓ {{ httpService.getTransation().PrioritySupport }}</div>
        <div class="benefit-compact benefit-mobile-simple hidden-mobile">✓ {{ httpService.getTransation().PatternReaderPaidFeature }}</div>
        <div class="benefit-compact visible-mobile-only">✓ {{ httpService.getTransation().PrintPDF }}</div>
      </div>

      <!-- Guarantee Badge -->
      <div class="guarantee-compact hidden-mobile">
        ✓ {{ httpService.getTransation().MoneyBackGuarantee }}
      </div>
      
      <div class="button-wrapper">
        <button
          mat-raised-button
          class="subscription-button subscription-button-featured"
          [disabled]="data.subscriptionType === subscriptionTypes.Monthly"
          [mat-dialog-close]="data"
          (click)="onClickSubscription(subscriptionTypes.Monthly)"
        >
          <span *ngIf="data.subscriptionType !== subscriptionTypes.Monthly">{{ httpService.getTransation().StartMonthlyPlan }}</span>
          <span *ngIf="data.subscriptionType === subscriptionTypes.Monthly">{{ httpService.getTransation().CurrentPlan }}</span>
          <mat-icon *ngIf="data.subscriptionType !== subscriptionTypes.Monthly" class="button-arrow-icon">arrow_forward</mat-icon>
        </button>
      </div>
    </div>

    <!-- YEARLY PLAN -->
    <div
      class="subscription-item subscription-item-yearly"
      [ngClass]="{ 'subscription-item-selected' : data.subscriptionType === subscriptionTypes.Yearly }"
    >
      <div class="subscription-best-value">
        <span class="hidden-mobile-inline">{{ httpService.getTransation().TwoMonthsFree }}</span>
        <span class="visible-mobile-inline">{{ httpService.getTransation().TwoMonthsFree }}</span>
      </div>
      <div class="subscription-title">
        {{ httpService.getTransation().YEARLY }}
      </div>
      <div class="subscription-price-container">
        <div class="subscription-price-yearly">
          <span class="currency-symbol">$</span><span class="price-number">50</span>
          <span class="price-period">/year</span>
        </div>
        <div class="subscription-price-monthly">
          {{ httpService.getTransation().OnlyPricePerMonth }}
        </div>
        <div class="subscription-savings">
          {{ httpService.getTransation().SaveAmount }}
        </div>
      </div>
      <div class="subscription-subtitle-secondary">
        {{ httpService.getTransation().BilledAnnually }}
      </div>
      
      <!-- Simplified Benefits -->
      <div class="benefits-list-compact">
        <div class="benefit-compact">✓ {{ httpService.getTransation().UnlimitedPatterns }}</div>
        <div class="benefit-compact benefit-mobile-simple hidden-mobile">✓ {{ httpService.getTransation().HDExport }}</div>
        <div class="benefit-compact benefit-mobile-simple hidden-mobile">✓ {{ httpService.getTransation().PDFSavePrint }}</div>
        <div class="benefit-compact benefit-mobile-simple hidden-mobile">✓ {{ httpService.getTransation().PrioritySupport }}</div>
        <div class="benefit-compact benefit-mobile-simple hidden-mobile">✓ {{ httpService.getTransation().PatternReaderPaidFeature }}</div>
        <div class="benefit-compact visible-mobile-only">✓ {{ httpService.getTransation().PrintPDF }}</div>
      </div>

      <!-- Guarantee Badge -->
      <div class="guarantee-compact hidden-mobile">
        ✓ {{ httpService.getTransation().MoneyBackGuarantee }}
      </div>
      
      <div class="button-wrapper">
        <button
          mat-raised-button
          class="subscription-button"
          [disabled]="data.subscriptionType === subscriptionTypes.Yearly"
          color="primary"
          [mat-dialog-close]="data"
          (click)="onClickSubscription(subscriptionTypes.Yearly)"
        >
          <span *ngIf="data.subscriptionType !== subscriptionTypes.Yearly">{{ httpService.getTransation().StartYearlyPlan }}</span>
          <span *ngIf="data.subscriptionType === subscriptionTypes.Yearly">{{ httpService.getTransation().CurrentPlan }}</span>
          <mat-icon *ngIf="data.subscriptionType !== subscriptionTypes.Yearly" class="button-arrow-icon">arrow_forward</mat-icon>
        </button>
      </div>
    </div>

    <!-- FREE PLAN - Right (De-emphasized) -->
    <div
      class="subscription-item subscription-item-free"
      [ngClass]="{ 'subscription-item-selected' : data.subscriptionType === subscriptionTypes.None }"
    >
      <div class="subscription-no-best-value"></div>
      <div class="subscription-title">
        {{ httpService.getTransation().FREE }}
      </div>
      <div class="subscription-price">
        <span class="currency-symbol">$</span><span class="price-number">0</span>
      </div>
      <div class="subscription-subtitle">
        {{ httpService.getTransation().NoCharge }}
      </div>
      
      <!-- Simplified Free Plan Limitations -->
      <div class="benefits-list-compact">
        <div class="benefit-limited-compact">✗ {{ httpService.getTransation().OnlyThreePatterns }}</div>
        <div class="benefit-limited-compact benefit-mobile-simple hidden-mobile">✗ {{ httpService.getTransation().StandardQuality }}</div>
        <div class="benefit-limited-compact benefit-mobile-simple hidden-mobile">✗ {{ httpService.getTransation().NoPDFExport }}</div>
        <div class="benefit-limited-compact benefit-mobile-simple hidden-mobile">✗ {{ httpService.getTransation().EmailSupportOnly }}</div>
        <div class="benefit-limited-compact visible-mobile-only">✗ {{ httpService.getTransation().PlanFreeDescription2 }}</div>
      </div>
      
      <div class="button-wrapper">
        <button
          mat-raised-button
          class="subscription-button"
          [disabled]="data.subscriptionType === subscriptionTypes.None"
          color="primary"
          [mat-dialog-close]="data"
          (click)="onClickSubscription(subscriptionTypes.None)"
        >
          <span *ngIf="data.subscriptionType !== subscriptionTypes.None">{{ httpService.getTransation().ContinueFree }}</span>
          <span *ngIf="data.subscriptionType === subscriptionTypes.None">{{ httpService.getTransation().CurrentPlan }}</span>
          <mat-icon *ngIf="data.subscriptionType !== subscriptionTypes.None" class="button-arrow-icon">arrow_forward</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Trust Footer - Hidden on mobile -->
  <div class="trust-footer hidden-mobile">
    <div class="trust-content">
      <mat-icon class="trust-icon-small trust-icon-community">groups</mat-icon>
      <span class="trust-item">{{ httpService.getTransation().JoinThousandsCreators }}</span>
      <span class="trust-separator">•</span>
      <mat-icon class="trust-icon-small trust-icon-security">lock</mat-icon>
      <span class="trust-item">{{ httpService.getTransation().SecureCheckout }}</span>
      <span class="trust-separator">•</span>
      <mat-icon class="trust-icon-small trust-icon-flexibility">event_available</mat-icon>
      <span class="trust-item">{{ httpService.getTransation().CancelAnytime }}</span>
    </div>
  </div>
</div>
